import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';
import Header from '../components/Header';
import BackToDashboard from '../components/BackToDashboard';

const SubscriptionSuccess: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthStore();
  const [redirecting, setRedirecting] = useState(true);
  const sessionId = searchParams.get('session_id');
  const hasValidSession = !!(sessionId && isAuthenticated);

  useEffect(() => {
    if (hasValidSession) {
      const t = setTimeout(() => {
        setRedirecting(false);
        navigate('/dashboard');
      }, 2000);
      return () => clearTimeout(t);
    }
    setRedirecting(false);
  }, [hasValidSession, navigate]);

  return (
    <div className="min-h-screen flex flex-col bg-slate-50">
      <Header activeTab="intelligence" />
      <main className="flex-1 max-w-2xl mx-auto w-full px-6 py-12 flex flex-col items-center justify-center">
        <BackToDashboard className="self-start mb-8" />
        <div className="text-center">
          <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-10 h-10 text-emerald-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 className="text-2xl font-black text-slate-900 mb-2">
            {hasValidSession ? 'Subscription Activated!' : 'Payment Successful'}
          </h2>
          <p className="text-slate-600 mb-6">
            {hasValidSession && redirecting
              ? 'Redirecting to dashboard...'
              : 'Your subscription is now active. Enjoy your new plan!'}
          </p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link
              to="/dashboard"
              className="px-6 py-3 bg-indigo-600 text-white font-bold rounded-lg hover:bg-indigo-700 transition-colors"
            >
              Go to Dashboard
            </Link>
            {!isAuthenticated && (
              <Link
                to="/"
                className="px-6 py-3 bg-slate-100 text-slate-700 font-bold rounded-lg hover:bg-slate-200 transition-colors"
              >
                Go to Home
              </Link>
            )}
          </div>
        </div>
      </main>
    </div>
  );
};

export default SubscriptionSuccess;
